module.exports = __webpack_public_path__ + "assets/img/binding-1.fd38868a.jpg";